export default __webpack_public_path__ + "static/media/Logo.0bac2605.webp";